import React from 'react';
import { motion } from 'framer-motion';
const stats = [{
  value: '+500',
  label: 'barberos confían'
}, {
  value: '150 pág.',
  label: 'método completo'
}, {
  value: '5 bonos',
  label: 'incluidos'
}, {
  value: '4.9/5 ⭐',
  label: 'calificación'
}];
export function StatsBar() {
  return <section aria-label="Números" className="border-b border-ink-700 bg-ink-900" data-id="element-176" data-mp="1jckegnqlcwyq">
      <div className="mx-auto grid w-full max-w-page grid-cols-2 gap-px bg-ink-700 sm:grid-cols-4" data-id="element-177" data-mp="1ed7indhqsfk0">
        {stats.map((stat, i) => <motion.div key={stat.label} initial={{
        opacity: 0,
        y: 12
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4,
        delay: i * 0.07
      }} className="bg-ink-900 px-5 py-8 text-center" data-id="element-178" data-mp="19lg3s07y7y9p" data-mpi={i}>
            <p className="display text-3xl text-bone sm:text-4xl" data-id="element-179" data-mp="vler7nibn2ee">{stat.value}</p>
            <p className="mt-2 text-[11px] font-semibold uppercase tracking-[0.18em] text-ash" data-id="element-180" data-mp="qnd9b5wmt94i">
              {stat.label}
            </p>
          </motion.div>)}
      </div>
    </section>;
}